<template>
  <div class="message-nav-list" v-if="categoryData">
    <div
      v-for="item in categoryData"
      :key="item.id"
      @click="clickEvent(item)"
      :class="{ selected: item.id === currentCategory?.id }"
      class="list-item"
    >
      <div class="list-item-content">
        <div class="left">
          <a-badge :count="item.unReadCount" :overflowCount="99" :offset="[-5, 3]">
            <!-- 通知分类icon,本地图片对应写死,0表示系统通知图标；1：故障通知图标、2：告警通知图标、3：离线通知图标、4：维护通知息图标 -->

            <!-- 系统通知 -->
            <Icon
              type="setting2"
              :class="`badge-icon badge-icon-${item.type}`"
              v-if="item.type === 0"
            />

            <!-- 离线通知 -->
            <a-icon
              type="close-circle"
              theme="filled"
              :class="`badge-icon badge-icon-${item.type}`"
              v-else-if="item.type === 3"
            />

            <!-- 维护通知 -->
            <a-icon
              type="tool"
              theme="filled"
              :class="`badge-icon badge-icon-${item.type}`"
              v-else-if="item.type === 4"
            />

            <a-icon
              type="info-circle"
              theme="filled"
              :class="`badge-icon badge-icon-${item.type}`"
              v-else
            />
          </a-badge>
        </div>
        <div class="right" :class="{ 'right-one': !item.lastestMessage || search }">
          <div class="flex-space-between">
            <span class="title" :class="{ 'title-one': !item.lastestMessage || search }">
              {{ item.name }}
              <i v-if="search"> {{ item.list?.length || '0' }}{{ $t('message_search_unit') }} </i>
            </span>
            <span class="time" v-if="item.lastestMessage">
              {{ item.lastestMessage?.createTime | formatDate }}
            </span>
          </div>
          <div class="content" v-if="item.lastestMessage">{{ item.lastestMessage?.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    categoryData: Array,
    currentCategory: Object,
    clickEvent: Function,
    search: Boolean,
  },
};
</script>
<style lang="less" scoped>
.message-nav-list {
  .list-item {
    min-height: 80px;
    border-radius: 8px;
    background-color: #f9f9fd;
    color: #71717a;
    font-size: 14px;
    margin-top: 16px;
    cursor: pointer;
    padding: 16px 24px;

    .list-item-content {
      display: flex;
      justify-content: left;
    }

    .left {
      margin-right: 16px;
      display: flex;
      align-items: center;

      .badge-icon {
        width: 46px;
        height: 46px;
        font-size: 46px;

        // 故障图标
        &.badge-icon-1 {
          color: #f5222d;
        }

        // 告警图标
        &.badge-icon-2 {
          color: #faad14;
        }
      }
    }

    .right-one {
      display: flex;
      align-items: center;
      width: 100%;
      .title {
        margin-bottom: 0;
      }
    }
    .right {
      width: 100%;

      .title-one {
        width: 100%;
      }
      .title {
        color: #18181a;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 5px;
        i {
          float: right;
          font-style: normal;
        }
      }

      .time {
        color: #71717a;
        font-size: 12px;
      }

      .content {
        color: #71717a;
        font-size: 14px;
        line-height: 22px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 设置显示的行数 */
        line-clamp: 3; /* 设置显示的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &:hover {
      color: #1838d9;
      background-color: #eee;

      .title,
      .time,
      .content {
        color: #1838d9;
      }
    }

    &.selected {
      color: #fdfeff;
      background-color: #1838d9;

      .title,
      .time,
      .content {
        color: #fdfeff;
      }
    }
  }
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
